module.exports = __webpack_public_path__ + "static/media/nutricion.3f82c8c3.png";